import { Link } from "gatsby"
import Hel from "@onestore/hel/dist/Hel"
import { default as homeTheme } from "@onestore/hel/dist/theme/home"
import { ThemeProvider } from "@ionos-web-design-system/react"
import "./styles.css"

export const wrapPageElement = ({ element }) => (
  <Hel brand="home" theme={homeTheme} env="production" linkComponent={Link}>
    <ThemeProvider>{element}</ThemeProvider>
  </Hel>
)
